import { render, staticRenderFns } from "./TspTripStatsContent.vue?vue&type=template&id=3fddb9c2"
import script from "./TspTripStatsContent.vue?vue&type=script&lang=ts"
export * from "./TspTripStatsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports